/* src/app/timeline-transport/partals/timeline-transport-toolbar/timeline-transport-toolbar.component.scss */
.datePicker {
  display: block;
  position: fixed;
  transform: translateX(-50%);
  z-index: 1045;
  cursor: default;
}
.timelineToolbarContainer {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  overflow-x: auto;
  overflow-y: hidden;
  position: sticky;
  top: 3.5rem;
  margin-top: -2.5rem;
  margin-left: -24rem;
  margin-right: -2rem;
  width: calc(100% + 26rem);
  z-index: 1035;
  padding: 0.75rem 1.5rem 0.75rem 6rem;
  background: #0f172a;
  border-bottom: 3px solid #006498;
}
.timelineToolbarContainer .btn-secondary {
  background: #1e293b !important;
  border: 1px solid #1e293b !important;
  color: #f1f5f9 !important;
  box-shadow: none !important;
}
.timelineToolbarContainer .btn-secondary:hover,
.timelineToolbarContainer .btn-secondary:focus {
  background: #006498 !important;
  border-color: #006498 !important;
  color: #fff !important;
}
.timelineToolbarContainer input[type=date] {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #f1f5f9;
}
.timelineToolbarContainer input[type=date]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
.timelineToolbarContainer input[type=text].form-control,
.timelineToolbarContainer select.form-control {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #f1f5f9;
}
.timelineToolbarContainer input[type=text].form-control::placeholder,
.timelineToolbarContainer select.form-control::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.timelineToolbarContainer input[type=text].form-control option,
.timelineToolbarContainer select.form-control option {
  background: #1e293b;
  color: #f1f5f9;
}
.presenceChips {
  display: flex;
  align-items: center;
}
.presenceChip {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 2px solid #0f172a;
  margin-left: -0.5rem;
}
.presenceChip:first-child {
  margin-left: 0;
}
.toolbarSearchHint {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.65rem;
  white-space: nowrap;
}
.toolbarGroups {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.75rem;
}
.toolbarGroup {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.4rem;
}
.toolbarSelectionRow {
  margin-top: 0.5rem;
  padding: 0.6rem 1rem;
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow-x: auto;
}
.toolbarSelectionCount {
  font-size: 0.7rem;
  font-weight: 600;
  color: #006498;
  background: #e6f2f8;
  border-radius: 999px;
  padding: 0.25rem 0.6rem;
  white-space: nowrap;
}
.toolbarDivider {
  width: 1px;
  align-self: stretch;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 0.1rem;
}
.toolbarDividerLight {
  background: #e2e8f0;
}
.colorCodeContainer {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 0.5rem;
  color: #1e293b;
}
.colorCodeKeyLabel {
  font-weight: 600;
  margin-right: 0.25rem;
}
.colorCodeChip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 500;
}
.colorCodeSwatch {
  display: inline-block;
  width: 0.85rem;
  height: 0.85rem;
  border-radius: 50%;
}
.chatToggleButton {
  position: relative;
  background: transparent;
  border: 0;
  box-shadow: none;
  padding: 0;
}
.chatToggleButton i {
  font-size: 1.7rem;
  color: #f1f5f9;
}
.chatToggleButton:hover i {
  color: #006498;
  cursor: pointer;
}
.chatUnreadBadge {
  position: absolute;
  top: -0.3rem;
  right: -0.5rem;
  font-size: 0.65rem;
  font-weight: 700;
  color: white;
  background: #dc2626;
  border-radius: 999px;
  min-width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  text-align: center;
  padding: 0 0.25rem;
}
.dateSelectorContainer {
  display: flex;
  flex-flow: row wrap;
}
.dateSelectorContainer button {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: #f1f5f9;
}
.dateSelectorContainer i {
  font-size: 2rem;
  color: #f1f5f9;
}
.dateSelectorContainer i:hover {
  color: #006498;
  cursor: pointer;
}
.dateSelectorContainer .dateSelectorBox {
  position: relative;
  background-color: transparent;
  padding: 0.3rem;
  width: 20rem;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 0.7rem;
  color: #f1f5f9;
  font-weight: bold;
}
.dateSelectorContainer .dateSelectorBox:hover {
  color: #4db8f0;
  cursor: pointer;
}
.vehicleTypeSwitcher {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  padding: 0.2rem;
  gap: 0.2rem;
}
.vehicleTypeSwitcher .btn {
  border: none;
  border-radius: 999px;
  padding: 0.3rem 0.9rem;
  box-shadow: none !important;
  background: transparent;
  color: rgba(255, 255, 255, 0.75);
}
.vehicleTypeSwitcher .btn.active {
  background: #006498 !important;
  color: white;
}
/*# sourceMappingURL=timeline-transport-toolbar.component.css.map */
